import {
  BOPINSTITUTION_TABLE,
  GET_BOPINSTITUTIONS_LIST_PENDING,
  GET_BOPINSTITUTIONS_LIST_FULFILLED,
  GET_BOPINSTITUTIONS_LIST_REJECTED,
  GET_BOPINSTITUTION_PENDING,
  GET_BOPINSTITUTION_FULFILLED,
  GET_BOPINSTITUTION_REJECTED,
  DELETE_BOPINSTITUTION_FULFILLED,
  DELETE_BOPINSTITUTION_PENDING,
  ADD_BOPINSTITUTION_FULFILLED,
  UPDATE_BOPINSTITUTION_FULFILLED
} from '../../actions/action-constants'
const initialState = {
  title: 'BOP Institutions',
  tablename: BOPINSTITUTION_TABLE,
  bopinstitutions: [],
  loadingList: false,
  errors: []
}
const reducerBOPInstitutions = (state = initialState, action) => {
  var dataUndefinedTestReturn
  switch (action.type) {
    case GET_BOPINSTITUTION_PENDING:
    case GET_BOPINSTITUTIONS_LIST_PENDING:
    case DELETE_BOPINSTITUTION_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_BOPINSTITUTIONS_LIST_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        bopinstitutions: dataUndefinedTestReturn
      }
      break
    case GET_BOPINSTITUTION_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        bopinstitutions: dataUndefinedTestReturn
      }
      break
    case DELETE_BOPINSTITUTION_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        deleteSuccess: true
      }
      break
    case ADD_BOPINSTITUTION_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        addSuccess: true
      }
      break
    case UPDATE_BOPINSTITUTION_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        updateSuccess: true
      }
      break
    case GET_BOPINSTITUTIONS_LIST_REJECTED:
    case GET_BOPINSTITUTION_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break
    default:
      return state
  }
  return state
}
export default reducerBOPInstitutions
